export const departmentRelatedProgramsFields = [
  'id',
  '_id',
  'programGroupId',
  'deprecatedProgramGroupId',
  'name',
  'longName',
  'catalogDescription',
  'description',
  'transcriptDescription',
  'catalogDisplayName',
  'degreeDesignation',
  'degreeDesignations',
  'type',
  'fieldOfStudy',
  'hegisCode',
  'cipCode',
]

export const departmentRelatedCoursesFields = [
  'id',
  '_id',
  'courseGroupId',
  'deprecatedCourseGroupId',
  'courseNumber',
  'subjectCode',
  'code',
  'name',
  'longName',
  'catalogDisplayName',
  'description',
  'catalogDescription',
  'transcriptDescription',
  'credits',
  'requirementDesignation',
  'attributes',
  'components',
  'career',
]
